import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { NavController, ToastController, LoadingController, PopoverController } from '@ionic/angular';
import { SigninService } from './signin.service';
import { AlertManagementService } from '../pages/alert-management/alert-management.service';
import { GlobalService, version, mobile } from '../global.config';
import { RealTimeRecord } from '../model/real-time';
import { Group } from '../model/data-managemnt';
import { User } from './credentials';
import { Credentials } from './credentials';
import { Router } from '@angular/router';
import { AddServerComponent, NewServer } from './add-server/add-server.component';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, Subject } from 'rxjs';
import { AnimationController } from '@ionic/angular';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
})
export class SigninComponent implements OnInit, OnDestroy {
  version: String = version;
  mobile: string = mobile;

  token: any;
  buttonColor: string = this.getButtonColor();
  loader: any;
  showing: boolean;
  groups: Group[];
  login: String;
  mdp: String;
  currentuser: User;
  allGroups: Subscription;
  newRealTimeRecords: RealTimeRecord[];
  oldRealTimeRecords: RealTimeRecord[];
  allRealTimeRecords: Subscription;
  searchWord: string = '';
  loginTest: String;
  mdpTest: String;
  server: string = '';
  currentLang: string = '';
  serverList: any[] = [];
  credentials: Credentials;
  loading: boolean = false;
  photo: String;
  newServers: NewServer[] = [];
  isActiveToggleTextPassword: Boolean = true;
  direction: string = 'ltr';

  private languageSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  constructor(
    public loadingCtrl: LoadingController,
    public navCtrl: NavController,
    private signinService: SigninService,
    private alertManagementService: AlertManagementService,
    private toastController: ToastController,
    private globalService: GlobalService,
    public router: Router,
    private popoverController: PopoverController,
    public translate: TranslateService,
    private animationCtrl: AnimationController,
    private elementRef: ElementRef
  ) {
    this.currentuser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    this.credentials = new Credentials();

    this.initializeServer();

    if (this.currentuser && this.currentuser.username) {
      this.credentials.username = this.currentuser.username;
      this.credentials.password = this.currentuser.password;
      if (this.server && this.currentuser.username && this.currentuser.password) {
        this.globalService.setservername(this.server);
        this.Signing();
      }
    }

  }

  ngOnInit() {
    this.languageSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(lang => {
      this.applyLanguageChange(lang);
    });

    if (localStorage.getItem('lang') == null) {
      this.currentLang = 'fr';
      this.direction = 'ltr';
      this.translate.setDefaultLang("fr");
      localStorage.setItem('lang', 'fr');
      this.translate.use('fr');
    } else {
      let lang = localStorage.getItem('lang') || 'fr';
      this.currentLang = lang;
      this.translate.setDefaultLang(lang);
      this.translate.use(lang);
      this.direction = (lang === 'ar') ? 'rtl' : 'ltr';
    }
    this.applyDirectionToComponent();

    this.loadSavedServers();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private initializeServer() {
    const savedServer = localStorage.getItem('server');

    if (savedServer && savedServer.trim() !== '') {
      this.server = savedServer;
    } else {
      this.server = this.getDefaultServer();
      localStorage.setItem('server', this.server);
    }

    this.globalService.setservername(this.server);
  }

  private getButtonColor(): string {
    switch(this.version) {
      case 'traci':
        return '#3880ff';
      case 'finek':
        return 'linear-gradient(-225deg, #22E1FF 0%, #1D8FE1 48%, #625EB1 100%)';
      case 'fleet':
      default:
        return '#3880ff';
    }
  }

  private getDefaultServer(): string {
    switch(this.version) {
      case 'finek':
        return 'finek.com.tn';
      case 'digitecom':
        return 'www.digitecom.tn';
      case 'mekatech':
        return 'mekatech.tn';
      case 'traci':
        return 'traci.tn';
      case 'slama':
        return 'gpstds.lumiere.tn';
      case 'fleet':
        return 'fleet.tn';
      case 'fasttrack':
        return 'fasttrack.tn';
      default:
        return '';
    }
  }

  private applyDirectionToComponent() {
    const hostElement = this.elementRef.nativeElement;
    hostElement.dir = this.direction;
    hostElement.classList.remove('rtl-component', 'ltr-component');
    hostElement.classList.add(this.direction === 'rtl' ? 'rtl-component' : 'ltr-component');
  }

  loadSavedServers() {
    switch(this.version) {
      case 'finek':
        this.serverList = [{serverName: "FINEK", serverLink: "finek.com.tn"}];
        break;
      case 'traci':
        this.serverList = [{serverName: "TRACI", serverLink: "traci.tn"}];
        break;
      case 'mekatech':
        this.serverList = [{serverName: "MEKATECH", serverLink: "mekatech.tn"}];
        break;
      case 'digitecom':
        this.serverList = [{serverName: "DIGITECOM", serverLink: "www.digitecom.tn"}];
        break;
      case 'slama':
        this.serverList = [{serverName: "SLAMAFLEET", serverLink: "gpstds.lumiere.tn"}];
        break;
      case 'fasttrack':
        this.serverList = [{serverName: "FASTTRACK", serverLink: "fasttrack.tn"}];
        break;
      case 'fleet':
     // default:
        this.serverList = [{serverName: "FLEET", serverLink: "fleet.tn"}];
        break;
      
    }

    const savedServersString = localStorage.getItem('newServers');

    if (savedServersString) {
      try {
        this.newServers = JSON.parse(savedServersString);

        this.newServers.forEach(server => {
          const exists = this.serverList.some(s => s.serverLink === server.serverLink);
          if (!exists) {
            this.serverList.push({
              serverName: server.serverName,
              serverLink: server.serverLink
            });
          }
        });
      } catch (error) {
        this.newServers = [];
        localStorage.removeItem('newServers');
      }
    }

    const currentServerFromStorage = localStorage.getItem('server');
    if (currentServerFromStorage && currentServerFromStorage.trim() !== '') {
      const serverExists = this.serverList.some(s => s.serverLink === currentServerFromStorage);
      if (!serverExists) {
        const customServerName = this.generateCustomServerName(currentServerFromStorage);
        this.serverList.push({
          serverName: customServerName,
          serverLink: currentServerFromStorage
        });

        const newCustomServer = {
          serverName: customServerName,
          serverLink: currentServerFromStorage
        };
        this.newServers.push(newCustomServer);
        localStorage.setItem('newServers', JSON.stringify(this.newServers));
      }
    }

    this.validateCurrentServer();
  }

  private generateCustomServerName(serverLink: string): string {
    let name = serverLink.replace(/^(https?:\/\/)?(www\.)?/, '').replace(/\/$/, '');

    const parts = name.split('.');
    if (parts.length > 0) {
      name = parts[0];
    }

    name = name.charAt(0).toUpperCase() + name.slice(1);

    let finalName = name;
    let counter = 1;
    while (this.serverList.some(s => s.serverName.toLowerCase() === finalName.toLowerCase())) {
      finalName = `${name} ${counter}`;
      counter++;
    }

    return finalName;
  }

  private validateCurrentServer() {
    if (!this.server) {
      this.server = this.getDefaultServer();
      localStorage.setItem('server', this.server);
      this.globalService.setservername(this.server);
      return;
    }

    const serverExists = this.serverList.some(s => s.serverLink === this.server);

    if (serverExists) {
      localStorage.setItem('server', this.server);
      this.globalService.setservername(this.server);
    } else {
      this.server = this.getDefaultServer();
      localStorage.setItem('server', this.server);
      this.globalService.setservername(this.server);
    }
  }

  getLogo(): string {
    switch(this.version) {
      case 'finek':
        return 'https://finek.com.tn/images/mobile/finek-logo-connect.png';
      case 'fleet':
        return 'https://fleet.tn/images/mobile/fleet-logo.png';
      case 'traci':
        return 'https://traci.tn/images/mobile/traci-logo.png';
      case 'mekatech':
        return 'https://mekatech.tn/images/mobile/logomekatech.png';
      case 'digitecom':
        return 'https://traci.tn/images/mobile/logo_traci.png';
      case 'slama':
        return 'https://gpstds.lumiere.tn/images/logoslama.png';
      //case 'fasttrack':
        //return 'https://finek.com.tn/images/signin-fasttrack.png';
      default:
        return 'https://fleet.tn/images/mobile/fleet-logo.png';
    }
  }

  switchLanguage(lang: string) {
    if (this.translate.currentLang === lang) {
      return;
    }

    this.languageSubject.next(lang);
  }

  private applyLanguageChange(lang: string) {
    this.translate.use(lang);
    this.translate.currentLang = lang;
    this.currentLang = lang;
    localStorage.setItem('lang', lang);

    this.direction = (lang === 'ar') ? 'rtl' : 'ltr';
    this.applyDirectionToComponent();

    let message = '';
    switch(lang) {
      case 'fr':
        message = 'Langue Français sélectionnée';
        break;
      case 'en':
        message = 'Language English selected';
        break;
      case 'ar':
        message = 'اللغة العربية المختارة';
        break;
      default:
        message = 'Language changed';
    }

    this.languageConfirmationMessage(message);
  }

  async languageConfirmationMessage(message: string) {
    const cssClass = this.version === 'finek' ? 'language-toast' : 'custom-toast';

    const toast = await this.toastController.create({
      message: message,
      duration: 2000,
      position: 'top',
      cssClass: cssClass,
      color: 'dark'
    });
    toast.present();
  }

  getMyStyles() {
    const imageUrl = this.getLoginBackgroundUrl();
    if (!imageUrl) {
      return {};
    }
    // Ionic paints via --background; also set classic background props as fallback.
    const layered = `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.3)), url(${imageUrl})`;
    return {
      '--background': `${layered} center / cover no-repeat`,
      'background-image': layered,
      'background-size': 'cover',
      'background-repeat': 'no-repeat',
      'background-position': 'center',
    };
  }

  private getLoginBackgroundUrl(): string | null {
    switch (this.version) {
      case 'finek':
        return 'https://finek.com.tn/images/mobile/road.jpg';
      case 'fleet':
        return 'https://fleet.tn/images/mobile/fleetLogin.jpg';
      case 'traci':
      case 'digitecom':
        return 'https://traci.tn/images/mobile/6.jpg';
      case 'tomtom':
        return 'https://traci.tn/images/tomtombg.png';
      case 'slama':
        return 'https://slama.fleet.tn/images/mobile/fleetLogin.jpg';
      case 'mekatech':
        return 'https://mekatech.tn/images/mobile/mekateckback.jpg';
      case 'fasttrack':
        return 'https://finek.com.tn/images/signin-fasttrack.png';
      default:
        return 'https://fleet.tn/images/mobile/fleetLogin.jpg';
    }
  }

  async Signing() {
    if (!this.validateForm()) {
      return;
    }

    this.loading = true;

    if (localStorage.getItem('id_token')) {
      localStorage.removeItem('id_token');
    }

    try {
      this.signinService.login(this.credentials).subscribe(
        (currentUser: any) => {
          if (currentUser == null) {
            this.displayError("Vous n'êtes pas autorisé!");
          } else {
            this.loading = false;
            localStorage.setItem('id_token', currentUser.token);
            currentUser.password = this.credentials.password;
            localStorage.setItem('currentUser', JSON.stringify(currentUser) || '{}');
            localStorage.setItem('server', this.globalService.getservername());
            this.displaySuccess(this.translate.instant("SIGNIN.SUCCESS"));

            // Register FCM token and insert into token_lut right after login
            void this.alertManagementService.registerPushToken(currentUser);

            setTimeout(() => {
              if (!this.signinService.isHasRole("ROLE_DRIVER")) {
                this.router.navigate(['client']);
              } else {
                this.router.navigate(['driver']);
              }
              this.signinService.authState = true;
              this.credentials.username = "";
              this.credentials.password = "";
            }, 1000);
          }
        },
        (error: any) => {
          this.handleLoginError(error);
          this.loading = false;
        }
      );
    } catch (e) {
      this.displayError("Une erreur s'est produite. Veuillez réessayer.");
      this.loading = false;
    }
  }

  validateForm(): boolean {
    if (!this.credentials.username && !this.credentials.password) {
      this.displayError(this.translate.instant('SIGNIN.ERROR_BOTH_REQUIRED'));
      return false;
    }

    if (!this.credentials.username) {
      this.displayError(this.translate.instant('SIGNIN.ERROR_USERNAME_REQUIRED'));
      return false;
    }

    if (!this.credentials.password) {
      this.displayError(this.translate.instant('SIGNIN.ERROR_PASSWORD_REQUIRED'));
      return false;
    }

    if (!this.server) {
      this.displayError(this.translate.instant('SIGNIN.ERROR_SERVER_REQUIRED'));
      return false;
    }

    return true;
  }

  handleLoginError(error: any) {
    if (error.status == 401) {
      let message = "Compte expiré! Merci de contacter votre administrateur";

      if (this.version == 'slama' || this.version == 'fleet') {
        message = "Compte expiré! Merci de contacter +21623307266";
      }

      this.displayStatus(message);
    } else {
      this.displayError(this.translate.instant('SIGNIN.ERROR_INVALID_CREDENTIALS'));
    }

    this.credentials.password = "";
  }

  async displayError(message: string) {
    const cssClass = this.version === 'finek' ? 'error-toast' : 'custom-toast error-toast';

    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: 'top',
      color: 'danger',
      cssClass: cssClass,
      buttons: [
        {
          icon: 'close',
          role: 'cancel'
        }
      ]
    });
    toast.present();
  }

  async displaySuccess(message: string) {
    const cssClass = this.version === 'finek' ? 'success-toast' : 'custom-toast success-toast';

    const toast = await this.toastController.create({
      message: message,
      duration: 2000,
      position: 'top',
      color: 'success',
      cssClass: cssClass
    });
    toast.present();
  }

  async displayStatus(message: string) {
    const cssClass = this.version === 'finek' ? 'status-toast' : 'custom-toast status-toast';

    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      position: 'middle',
      color: 'warning',
      cssClass: cssClass,
      buttons: [
        {
          text: 'OK',
          role: 'cancel'
        }
      ]
    });
    toast.present();
  }

  updateservername() {
    if (this.server && this.server.trim() !== '') {
      localStorage.setItem('server', this.server);
      this.globalService.setservername(this.server);
    } else {
      this.server = this.getDefaultServer();
      localStorage.setItem('server', this.server);
      this.globalService.setservername(this.server);
    }
  }

  async addServer(ev: any) {
    const cssClass = this.version === 'finek' ? 'server-popover' : 'custom-server-popover';
    const popoverConfig: any = {
      component: AddServerComponent,
      cssClass: cssClass,
      showBackdrop: true,
      id: "addServerPopover",
      backdropDismiss: true,
      alignment: "center",
    };

    if (this.version === 'finek') {
      popoverConfig.event = ev;
      popoverConfig.translucent = true;
    }

    const popover = await this.popoverController.create(popoverConfig);
    await popover.present();

    const { data, role } = await popover.onDidDismiss();

    if (data && data.newServer) {
      this.loadSavedServers();
      this.server = data.newServer.serverLink;
      localStorage.setItem('server', this.server);
      this.globalService.setservername(this.server);
    }
  }

  public toggleTextPassword(): void {
    this.isActiveToggleTextPassword = !this.isActiveToggleTextPassword;

    const passwordToggle = document.querySelector('.password-toggle');
    if (passwordToggle) {
      let animation;

      if (this.version === 'finek') {
        animation = this.animationCtrl.create()
          .addElement(passwordToggle)
          .duration(300)
          .iterations(1)
          .fromTo('transform', 'scale(1)', 'scale(1.2)')
          .fromTo('opacity', '0.7', '1')
          .afterStyles({
            transform: 'scale(1)',
            opacity: '0.7'
          });
      } else {
        animation = this.animationCtrl.create()
          .addElement(passwordToggle)
          .duration(200)
          .iterations(1)
          .fromTo('transform', 'scale(1) rotate(0deg)', 'scale(1.1) rotate(360deg)')
          .afterStyles({
            transform: 'scale(1) rotate(0deg)'
          });
      }

      animation.play();
    }
  }

  public getType() {
    return this.isActiveToggleTextPassword ? 'password' : 'text';
  }
}
